export const RELEASE_DETAILS: any = {'releaseNumber': 'production_1.1.199','releaseDate': 'Saturday, 3 October 2026 at 09:49'};